module.exports = __webpack_public_path__ + "img/galeria-captores-12.8944adab.png";